export const NAME = 'flashingTicket';

export const SET_FLASHING_TICKET_PARTNER_ID = 'SET_FLASHING_TICKET_PARTNER_ID';
export const REQUEST_FORM_SUBMIT_FLASHING_TICKET = 'REQUEST_FORM_SUBMIT_FLASHING_TICKET';
export const SUCCESS_FORM_SUBMIT_FLASHING_TICKET = 'SUCCESS_FORM_SUBMIT_FLASHING_TICKET';
export const FAILURE_FORM_SUBMIT_FLASHING_TICKET = 'FAILURE_FORM_SUBMIT_FLASHING_TICKET';



// WEBPACK FOOTER //
// ./src/services/flashing-ticket/constants.js